import { Link } from '@inertiajs/react';
import { type Region } from '../../types';
import styles from './prefecture-list.module.css';

type PrefectureListProps = {
  regions: Region[];
};

export function PrefectureList({ regions }: PrefectureListProps) {
  return (
    <div className={styles.root}>
      <ul className={styles.regions}>
        {regions.map((region, key) => (
          <li className={styles.region} key={key}>
            <div className={styles.regionName}>
              <span className={styles.regionAnchor}>{region.name}</span>
            </div>
            <ul className={styles.prefectures}>
              {region.prefectures.map((prefecture, key) => (
                <li className={styles.prefecture} key={key}>
                  <Link className={styles.prefectureAnchor} href={`/schools/${prefecture.toLowerCase()}/`} prefetch>
                    {prefecture}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}
